import { api } from "@/lib/api";
import { VehicleModelInput } from "@/types/vehicleModel.types";

export const modelService = {
  async getAllModels() {
    const response = await api.get("/vehicleModel");
    return response.data.data;
  },

  async createModel(model: VehicleModelInput) {
    const response = await api.post("/vehicleModel", model);
    return response.data.data;
  },

  async deleteModel(id: string) {
    const response = await api.delete(`/vehicleModel/${id}`);
    return response.data.data;
  },
};